__turbopack_context__.v({
  "fade-in": "SearchControls-module-scss-module__VaU-Vq__fade-in",
  "no-transform": "SearchControls-module-scss-module__VaU-Vq__no-transform",
  "rotate": "SearchControls-module-scss-module__VaU-Vq__rotate",
  "wrapper": "SearchControls-module-scss-module__VaU-Vq__wrapper",
});
